import { render } from "./TheMessageValidationLang.vue?vue&type=template&id=63a4aab0"
import script from "./TheMessageValidationLang.vue?vue&type=script&lang=js"
export * from "./TheMessageValidationLang.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__